export const htmlToMarkdown = (text: string): string =>
  text
    .replace(/<\/p>/g, '\n') // Replace paragraph endings with newlines
    .replace(/<\/?strong>/g, '**') // Bold text using Markdown style
    .replace(/<\/?em>/g, '*') // Italic text using Markdown style
    .replace(/<li class="ql-indent-1">/g, '  - ') // Indented list
    .replace(/<li>/g, '- ') // Regular list
    .replace(/<\/li>/g, '\n') // List item end
    .replace(/<\/?ol>/g, '') // Remove ordered list tags
    .replace(/<\/?ul>/g, '') // Remove unordered list tags
    .replace(/<blockquote>/g, '> ') // Blockquotes
    .replace(/<\/blockquote>/g, '\n') // End blockquote
    .replace(/<[^>]+>/g, '') // Remove remaining HTML tags
    .replace(/\n+/g, '\n') // Collapse multiple newlines
    .trim()
